<template>
  <a-card :bordered="false">
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['search_id','search_name','search_match_id','search_state']"
      :columns="columns"
      :queryParams="queryParams"
      row-key="erpProId"
      :leftSpace="30"
      :requestPromise="getMemberListPromise"
    >
      <a-form-item slot="search_id" label="门票ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.erpTicketId" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="search_name" label="门票名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.ticketName" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="search_match_id" label="已匹配门票ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.matchPlatformProId" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="search_state" label="匹配状态" v-bind="searchItemLayout">
        <a-select
          v-model="queryParams.matchStatus"
          placeholder="请输入"
          :allowClear="true"
          style="width: 100%">
          <a-select-option :value="0">待匹配</a-select-option>
          <a-select-option :value="1">已匹配</a-select-option>
        </a-select>
      </a-form-item>
      <span slot="erpProId">
        <a-tooltip placement="topLeft" :visible="true">
    <template slot="title">
      可将自有门票商品与直连数据匹配，匹配后您的门票将通过直连服务面向全网分销
    </template>
    门票ID
  </a-tooltip>
        </span>
      <a-form-item slot="operation">
        <span style="float: right">
          直连门票状态：
        <a-switch @change="setStatus" v-model="checkBox" checked-children="开" un-checked-children="关"/>
        </span>
      </a-form-item>
      <span slot="action" slot-scope="rowItem">
        <span v-if="rowItem.record.matchStatus===1">
          <a @click="goDetails(rowItem.record)">详情</a>
          <a-divider type="vertical"></a-divider>
        </span>
          <a @click="goManualMatch(rowItem.record)">匹配</a>
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'

export default {
  name: 'TicketConnection',
  mixins: [searchForm],
  data() {
    return {
      status: 0,//状态 0 为关闭 1为开启
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      totalProNum: 0,
      usedProNum: 0,
      staffStatusList: [],
      queryParams: {
        erpTicketId: '',
        matchPlatformProId: '',
        matchStatus: undefined,
        ticketName: ''
      },
      columns: [
        {
          dataIndex: 'erpProId',
          slots: { title: 'erpProId' }
        },
        {
          title: '门票名称',
          dataIndex: 'proName'
        },
        {
          title: '匹配状态',
          dataIndex: 'matchStatusStr'
        },
        {
          title: '已匹配门票ID',
          dataIndex: 'matchPlatformProId'
        },
        {
          title: '匹配时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      checkBox: false
    }
  },
  mounted() {
    this.queryStatus()
  },
  methods: {
    goDetails(record) {
      let query = {
        serverId: this.$route.query.serverId,
        serverUniqueId: this.$route.query.serverUniqueId,
        erpTicketId: record.erpProId,
        ticketName: record.proName
      }
      this.openNewPage('MatchDetails', query)
    },
    goManualMatch(record) {
      let query = {
        serverId: this.$route.query.serverId,
        serverUniqueId: this.$route.query.serverUniqueId,
        erpTicketId: record.erpProId,
        ticketName: record.proName
      }
      this.openNewPage('ManualMatch', query)
    },
    setStatus() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('erp/ticket/status', params)
        .then(res => {
          this.$refs.pageList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    queryStatus() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('erp/ticket/direct-status', params)
        .then(res => {
          this.checkBox = res === 1
          this.$refs.pageList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getMemberListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      if (this.checkBox) {
        return this.getHttpServices().getCloudProService().post('erp/searchErpTicketMatchList', params)
      } else {
        return new Promise((resolve, reject) => {
          const result = {
            pageSize: 10,
            pageNo: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }
    }
  }

}
</script>
<style lang="less">
.ant-tooltip-inner {
  width: 520px;
}
</style>